import Vue from 'vue';
import VueHtml2pdf from 'vue3-html2pdf';

Vue.component('VueHtml2pdf', VueHtml2pdf);
